import { useEffect } from "react";

const ImageTooltipSetup = ({ shadowRoot }) => {
  useEffect(() => {
    if (!shadowRoot) return;

    const TOOLTIP_ID = "easy-vision-container-image-alt";

    const removeTooltip = () => {
      const existingTooltip = shadowRoot.querySelector(`#${TOOLTIP_ID}`);
      if (existingTooltip) existingTooltip.remove();
    };

    const createTooltip = (text, isNightMode) => {
      const tooltip = document.createElement("div");
      tooltip.id = TOOLTIP_ID;
      tooltip.textContent = text;

      tooltip.style.cssText = `
        position: absolute;
        padding: 10px;
        pointer-events: none;
        font-family: ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT", "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif;
        font-weight: bold;
        font-size: 16px;
        background-color: ${isNightMode ? "#EFEFEF" : "#101010"};
        color: ${isNightMode ? "#101010" : "#EFEFEF"};
        border: 3px solid ${isNightMode ? "#101010" : "#EFEFEF"};
        border-radius: 3px;
        max-width: 320px;
        z-index: 9999;
      `;

      shadowRoot.appendChild(tooltip);
      return tooltip;
    };

    const handleMouseOver = (e) => {
      const img = e.target;
      if (!(img instanceof HTMLImageElement) || !img.alt) return;

      const isInsideValidContainer = img.closest('[imagedescription="1"]');
      if (!isInsideValidContainer) return;

      removeTooltip();

      const isNightMode = !!img.closest('[nightmode="1"]');
      const tooltip = createTooltip(img.alt, isNightMode);

      const updateTooltipPosition = (event) => {
        const hostRect = shadowRoot.host.getBoundingClientRect();
        requestAnimationFrame(() => {
          tooltip.style.top = `${event.clientY - hostRect.top - 40}px`;
          tooltip.style.left = `${event.clientX - hostRect.left + 15}px`;
        });
      };

      const handleMouseLeave = () => {
        removeTooltip();
        img.removeEventListener("mousemove", updateTooltipPosition);
        img.removeEventListener("mouseleave", handleMouseLeave);
      };

      img.addEventListener("mousemove", updateTooltipPosition);
      img.addEventListener("mouseleave", handleMouseLeave);
    };

    const cleanAllTooltips = () => removeTooltip();

    shadowRoot.addEventListener("mouseover", handleMouseOver);
    shadowRoot.addEventListener("click", cleanAllTooltips);
    shadowRoot.addEventListener("scroll", cleanAllTooltips);

    return () => {
      shadowRoot.removeEventListener("mouseover", handleMouseOver);
      shadowRoot.removeEventListener("click", cleanAllTooltips);
      shadowRoot.removeEventListener("scroll", cleanAllTooltips);
      removeTooltip();
    };
  }, [shadowRoot]);

  return null;
};

export default ImageTooltipSetup;
